/**
 * FORGOT PASSWORD — the ask-for-a-link screen (phone). D-08, docs/EMAIL.md.
 *
 * Bare chrome, like `login`, `landing` and `join`: its reader is by definition
 * locked out, so a header naming their crew would be describing a place they
 * cannot currently reach.
 *
 * No mirror exists for this screen — the prototype has no recovery flow — so
 * the frame is the JOIN screen's and the body is shared with desktop in
 * `components/RecoverCard.tsx`. It owes a DESIGN-CHANGELOG entry upstream.
 */

import { QuarterIcon } from '../components/QuarterIcon.tsx';
import { RecoverCard } from '../components/RecoverCard.tsx';

const M = {
  headFs: '13px',
  bodyFs: '10.5px',
  fieldFs: '12px',
  btnFs: 9,
  pad: '0',
};

export default function Recover(): JSX.Element {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '34px 16px 26px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <QuarterIcon u={2.5} />
        <div
          style={{
            fontFamily: 'var(--gt-font-pixel)',
            fontSize: '17px',
            color: 'var(--gt-text)',
            lineHeight: 1.6,
            marginTop: '16px',
          }}
        >
          GAMES TONIGHT<span style={{ color: 'var(--acc2)' }}>?</span>
        </div>
      </div>

      <div style={{ marginTop: '26px' }}>
        <RecoverCard m={M} />
      </div>
    </div>
  );
}
